import React, { useEffect } from 'react';
import { ErrorInfoIcon } from '../icons';
import { usePaymentOutageContext } from '../../providers/PaymentOutageProvider';
import { usePushEvents } from '../../hooks/PushEvents';
import { paymentOutageModalEvent } from '../../hooks/PushEvents/clevertapEvents';
import { Button, Modal } from '../ui';

const PaymentOutage: React.FC = () => {
    const { pushEvent } = usePushEvents();
    const { open, handleClose } = usePaymentOutageContext();

    useEffect(() => {
        if (open) {
            pushEvent(paymentOutageModalEvent);
        }
    }, [open, pushEvent]);

    return (
        <Modal
            open={open}
            onClose={(_, reason) => reason !== 'backdropClick' && handleClose()}
        >
            <div className="flex flex-col gap-4 align-middle justify-center w-[412px] mobile:w-full">
                <div className="flex align-middle justify-center mx-auto">
                    <ErrorInfoIcon />
                </div>
                <div className="text-body-medium-bold text-center text-primary">
                    Your gift failed due to a<br />
                    problem on our end
                </div>
                <div className="text-body-small text-center text-primary">
                    Our team is working to fix the issue. Thanks for your
                    patience.
                    <br />
                    <br />
                    We'll email you when your gift can be completed.
                </div>
                <Button
                    onClick={handleClose}
                    className="w-full"
                >
                    OK
                </Button>
            </div>
        </Modal>
    );
};

export default PaymentOutage;
